import { useContext } from 'react';

import { ThemeModeContext } from 'src/contexts';

export const useThemeMode = () => useContext(ThemeModeContext);
